export default {
  'Start at': 'Start at',
  'Set to current time': 'Set to current time',
  'Audio volume': 'Audio volume',
  'Video volume': 'Video volume',
  'Trim audio': 'Trim audio',
  'Audio will end with the video': 'Audio will end with the video.',
  'Trim': 'Trim',
}